/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const { useDebounce } = require('../utils/debounce');
const { useLiveDemoContext } = require('../base-live-demo-component/Provider/liveDemoContext');
const { brickCreationScript } = require('./constants');
const PreferencesService = require('../../../../services/preferencesService');
const { users } = require('../utils/utils');

const View = ({
  publicKey,
  theme,
  installments,
  showTitle = true,
  showPaymentButton = true,
  submitTitle,
  language,
  customVariables,
  customTexts,
  payerInfo,
  paymentMethod,
  amount,
}) => {
  const finalSubmitTitle = useDebounce(submitTitle, 2000);
  const debounceProps = [
    useDebounce(publicKey, 2000),
    useDebounce(theme, 2000),
    useDebounce(installments, 2000),
    useDebounce(showTitle, 2000),
    useDebounce(showPaymentButton, 2000),
    useDebounce(language, 2000),
    useDebounce(amount, 2000),
    useDebounce(paymentMethod, 2000),
  ];
  const { setBehaviorData } = useLiveDemoContext();

  React.useEffect(() => {
    const cachedPreferenceId = localStorage.getItem('preferenceId');
    const cachedAccessToken = localStorage.getItem('accessToken');
    const cachedPreferenceIdExpiration = localStorage.getItem('preferenceIdExpiration');

    let preferenceId = cachedPreferenceId;

    const setPaymentBricksPropsAndEval = (props, script, delay) => {
      window.paymentBricksProps = props;

      setTimeout(() => {
        setBehaviorData(prev => ({
          ...prev,
          showLayoutSpinner: false,
        }));
        window.eval(script);
      }, delay);
    };

    const getUserCustomInputs = () => {
      let customVariablesInput = {};
      let textsInput = {};
      let payerInput = {};

      try {
        customVariablesInput = JSON.parse(customVariables);
        textsInput = JSON.parse(customTexts);
        payerInput = JSON.parse(payerInfo);
      // eslint-disable-next-line no-empty
      } catch (e) {}

      return {
        customVariables: customVariablesInput,
        texts: textsInput,
        payer: payerInput,
      };
    };

    const userCustomInputs = getUserCustomInputs();

    const createPaymentMethodsPayload = (value, installments) => {
      const validMethods = ['creditCard', 'debitCard', 'ticket', 'bankTransfer', 'atm', 'onboarding_credits', 'wallet_purchase'];
      const payload = {};

      if (Array.isArray(value)) {
        const mercadoPagoMethods = [];

        for (const method of value) {
          if (validMethods.includes(method)) {
            if (method === 'onboarding_credits' || method === 'wallet_purchase') {
              mercadoPagoMethods.push(method);
            } else {
              payload[method] = 'all';
            }
          }
        }

        if (mercadoPagoMethods.length > 0) {
          payload.mercadoPago = mercadoPagoMethods;
        }
      }


      if (installments >= 1) {
        payload.maxInstallments = installments;
      }

      return payload;
    };

    const { accessToken, country } = users.find(item => item.user === publicKey);

    const createPaymentBricksProps = () => ({
      publicKey: publicKey || 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
      preferenceId: preferenceId || '',
      theme: theme || 'default',
      formSubmit: finalSubmitTitle || 'Pagar',
      language: language || 'pt-BR',
      hidePaymentButton: !showPaymentButton || false,
      hideFormTitle: !showTitle || false,
      paymentMethod: createPaymentMethodsPayload(paymentMethod, installments) || [],
      customVariables: userCustomInputs.customVariables,
      installments,
      amount: amount < '100' && country === 'CO' ? '100' : amount,
      texts: userCustomInputs.texts,
      payer: userCustomInputs.payer,
    });

    if (Date.now() > Number(cachedPreferenceIdExpiration) || accessToken !== cachedAccessToken) {
      (async () => {
        const preference = await PreferencesService.postPreferences(accessToken);
        preferenceId = preference?.id;
        const preferenceIdExpirationTime = Date.now() + 10 * 60 * 60 * 1000;

        localStorage.setItem('preferenceId', preferenceId);
        localStorage.setItem('preferenceIdExpiration', preferenceIdExpirationTime);

        localStorage.setItem('accessToken', accessToken);

        const props = createPaymentBricksProps();

        setPaymentBricksPropsAndEval(props, brickCreationScript, 1000);
      })();
    } else {
      const props = createPaymentBricksProps();

      setPaymentBricksPropsAndEval(props, brickCreationScript, 1000);
    }
  }, [
    ...debounceProps,
    customVariables,
    customTexts,
    payerInfo,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);
    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);

  return (
    <>
      <div id="paymentBrick_container" />
    </>
  );
};

module.exports = View;
